import { PureKnockoutView } from '@bingads-webui/knockout-view';
import template from './changebudget.pug';
import { ChangeBudgetActionViewModel } from './viewmodel';


export class ChangeBudgetActionView extends PureKnockoutView {
  initialize({
    i18n,
    accountCurrencyCode,
    budgetRange,
    selectedRule,
  }) {
    this.options = {
      i18n,
      accountCurrencyCode,
      budgetRange,
      selectedRule,
    };
    super.initialize(this.options);
    this.i18n = i18n;
  }

  get template() {
    return template;
  }

  get ViewModel() {
    return ChangeBudgetActionViewModel;
  }

  validate() {
    return this.viewModel.validate();
  }

  getUserAction() {
    return this.viewModel.getUserAction();
  }
}
